var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('survey-base',{attrs:{"id":String(_vm.id),"category":"事前登録","routerName":"Survey"}})}
var staticRenderFns = []

export { render, staticRenderFns }